import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { plusicon, PrakurtiCirculerLogo, refreshicon } from '../../components/imagepath';
import { ActionUpdateSolutionSlot, GetAllSolutionSlot } from '../../store/Actions/SolutionSlotAction';
import { useEffect, useState, useCallback } from 'react';
import { matchPermissions } from '../../utils/Permission';
import { generateQueryString } from '../../utils/functions';
import { Tag, Tooltip } from 'antd';
import AssignDoctorModal from '../../components/Modal/AssignDoctorModal';
import AdvancedTable from '../../components/AdvancedTable';
import { useDispatch, useSelector } from 'react-redux';
import { PERMISSIONS } from '../../constants';

const SolutionSlot = () => {
  const { SolutionSlot } = useSelector(state => state?.SolutionSlotBooking);
  const { userDetails } = useSelector(state => state?.auth);
  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.SOLUTIONS.SLOTS);
  const canCreate = matchPermissionsForUser(PERMISSIONS.SOLUTIONS.CREATE);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.SOLUTIONS.UPDATE);
  const canExport = matchPermissionsForUser(PERMISSIONS.SOLUTIONS.EXPORT);
  const [modal, SetModal] = useState({ is: false, id: '' });

  // const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  // const [arrowAtCenter, setArrowAtCenter] = useState(false);
  // const [IsSearching, setIsSearching] = useState(false);

  const pageSize = 10;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = queryString.parse(location.search);
  // const Size = ResponsiveComponent()

  const [currentView, setCurrentView] = useState(localStorage.getItem('currentView'));
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortOn, setSortOn] = useState('date');


  const handleViewChange = view => {
    setCurrentView(view);
    localStorage.setItem('currentView', view);
    //   setSortOrder(view === 'Upcoming' ? 'asc' : 'desc');
    //   setSortOn(view === 'Upcoming' ? 'date' : 'date');
    // };

    switch (view) {
      case 'Upcoming':
        setSortOrder('asc');
        setSortOn('date');
        break;
      case 'Completed':
        setSortOrder('desc');
        setSortOn('date');
        break;
      case 'Cancelled':
      case 'InProgress':
        setSortOrder('asc');
        setSortOn('date');
        break;
      default:
        setSortOrder('asc');
        setSortOn('date');
        break;
    }
  };

  const filterConfig = [
    {
      id: 'customerName',
      label: 'Customer Name',
      type: 'text',
      placeholder: 'Search by name...',
    },
    {
      id: 'solutionName',
      label: 'Solution Name',
      type: 'text',
      placeholder: 'Search by solution...',
    },
    {
      id: 'phoneNo',
      label: 'Phone No.',
      type: 'text',
      placeholder: 'Search by phone...',
    },
    {
      id: 'status',
      label: 'Booking Status',
      type: 'select',
      options: [
        { value: 'Upcoming', label: 'Upcoming' },
        { value: 'Completed', label: 'Completed' },
        { value: 'Cancelled', label: 'Cancelled' },
        { value: 'InProgress', label: 'InProgress' },
      ],
    },
    {
      id: 'dateRange',
      label: 'Date Range',
      type: 'dateRange',
    },
  ];

  const handleStatusUpdate = (recordId, newStatus) => {
    dispatch(
      ActionUpdateSolutionSlot(
        {
          Query: recordId,
          obj: {
            status: newStatus,
          },
        },
        () => setRefresh(true)
      )
    );
  };

  const fetchSolutionSlotData = useCallback(async (tableParams) => {
    const { page: tablePage, perPage, search, sortField, sortOrder: tableSortOrder, filters } = tableParams;

    // Parse URL params inside the function to avoid dependency loop
    const urlParams = queryString.parse(window.location.search);

    // Status and other filters can come from AdvancedTable or URL
    const statusFilter = filters?.status || urlParams.status || currentView;
    const customerNameFilter = filters?.customerName || urlParams.customerName || '';
    const SolutionNameFilter = filters?.solutionName || urlParams.solutionName || '';
    const phoneNoFilter = filters?.phoneNo || urlParams.phoneNo || '';

    // Date handling: AdvancedTable uses dateRange_start and dateRange_end in the URL
    // The internal filters object uses { start: Date, end: Date }
    let startDateFilter = filters?.dateRange?.start || urlParams.dateRange_start || urlParams.startDate || '';
    let endDateFilter = filters?.dateRange?.end || urlParams.dateRange_end || urlParams.endDate || '';

    // Always format to YYYY-MM-DD for consistent backend API behavior
    if (startDateFilter) startDateFilter = dayjs(startDateFilter, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');
    if (endDateFilter) endDateFilter = dayjs(endDateFilter, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');

    const newQuery = generateQueryString(
      ['page', tablePage || 1],
      ['perPage', perPage || 10],
      ['customerName', customerNameFilter],
      ['solutionName', SolutionNameFilter],
      ['phoneNo', phoneNoFilter],
      ['search', search || ''],
      ['sort', tableSortOrder || sortOrder],
      ['sortOn', sortField || sortOn],
      ['status', statusFilter],
      ['startDate', startDateFilter],
      ['endDate', endDateFilter]
    );

    return new Promise((resolve) => {
      dispatch(GetAllSolutionSlot(
        { Query: newQuery },
        (responseData, error) => {
          if (error) {
            resolve({ data: [], total: 0 });
            return;
          }
          resolve({
            data: responseData?.[0]?.docs || [],
            total: responseData?.[0]?.totalDocs || 0
          });
        }
      ));
    });
  }, [dispatch, currentView, sortOrder, sortOn]);

  useEffect(() => {
    setRefresh(false);
  }, [Refresh]);

  // Status color mapping
  const getStatusColor = (status) => {
    const colors = {
      'Upcoming': 'blue',
      'InProgress': 'orange',
      'Completed': 'green',
      'Cancelled': 'red',
    };
    return colors[status] || 'default';
  };

  const column = [
    {
      id: 'sr',
      name: '#',
      selector: 'sr',
      width: 50,
      cell: (record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span style={{ fontWeight: '500', color: '#666' }}>{calculatedIndex}</span>;
      },
    },
    {
      id: 'orderUniqueId',
      name: 'Order ID',
      selector: 'orderUniqueId',
      width: 160,
      cell: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {record?.isSimulation && (
            <Tooltip title="Simulation Mode">
              <img
                src={PrakurtiCirculerLogo}
                alt="sim"
                style={{ width: '16px', height: '16px', borderRadius: '50%' }}
              />
            </Tooltip>
          )}
          <Tooltip title={`Order: ${record?.orderUniqueId} | Click to view details`}>
            <Link
              to={`/order-history-overview/${record?.orderId}`}
              style={{ fontWeight: '500', color: '#1890ff' }}
            >
              {record?.orderUniqueId || '-'}
            </Link>
          </Tooltip>
        </div>
      ),
    },
    {
      id: 'customerInfo',
      name: 'Customer',
      selector: 'customerName',
      width: 200,
      cell: (record) => (
        <Tooltip
          title={
            <div>
              <div><strong>Name:</strong> {record?.customerName || '-'}</div>
              <div><strong>Phone:</strong> {record?.phoneNo || '-'}</div>
              {record?.parentCustomerName && (
                <div><strong>Primary:</strong> {record?.parentCustomerName}</div>
              )}
            </div>
          }
        >
          <div style={{ cursor: 'pointer' }}>
            <div style={{ fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {record?.customerName || '-'}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>{record?.phoneNo || '-'}</div>
            {record?.parentCustomerName && (
              <div style={{ fontSize: '11px', color: '#1890ff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                Primary: {record?.parentCustomerName}
              </div>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      id: 'solutionData',
      name: 'Program',
      selector: 'solutionData',
      width: 180,
      cell: (record) => {
        const programs = record?.solutionData?.map(s => s.solutionName).join(', ') || '-';
        return (
          <Tooltip title={programs}>
            <div>
              {/* {Array.isArray(record?.solutionData) && record?.solutionData.length > 0 ? (
                record?.solutionData.map((solution, index) => (
                  <Tag key={index} color="purple" style={{ marginBottom: '2px', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {solution.solutionName}
                  </Tag>
                ))
              ) : (
                <span style={{ color: '#999' }}>-</span>
              )} */}
             <Tag color="purple" style={{ marginBottom: '2px', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {record?.solutionData[0]?.solutionName || '--'}
                  </Tag>
            </div>
          </Tooltip>
        );
      },
    },
    {
      id: 'schedule',
      name: 'Schedule',
      selector: 'startDate',
      width: 160,
      cell: (record) => {
        const startDate = record.startDate ? dayjs(record.startDate).format('DD MMM YYYY') : '-';
        const endDate = record.endDate ? dayjs(record.endDate).format('DD MMM YYYY') : '-';
        const startShort = record.startDate ? dayjs(record.startDate).format('DD MMM') : '-';
        const endShort = record.endDate ? dayjs(record.endDate).format('DD MMM YY') : '-';
        return (
          <Tooltip title={`From: ${startDate} | To: ${endDate} | Duration: ${record?.totalDays || 0} days`}>
            <div style={{ cursor: 'pointer' }}>
              <div style={{ fontSize: '13px', fontWeight: '500' }}>{startShort} - {endShort}</div>
              <div style={{ marginTop: '2px' }}>
                <Tag color="cyan" style={{ fontSize: '11px' }}>
                  {record?.totalDays || 0} {record?.totalDays === 1 ? 'Day' : 'Days'}
                </Tag>
                {record?.isReschedule && (
                  <Tag color="orange" style={{ fontSize: '10px' }}>Rescheduled</Tag>
                )}
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      id: 'status',
      name: 'Status',
      selector: 'status',
      width: 120,
      cell: (record) => (
        <Tooltip title={`Status: ${record?.status}${record?.isSimulation ? ' (Test Booking)' : ''}`}>
          <div>
            <Tag
              color={getStatusColor(record?.status)}
              style={{ fontWeight: '500', borderRadius: '10px' }}
            >
              {record?.status || '-'}
            </Tag>
            {/* {record?.isSimulation && (
              <Tag color="default" style={{ fontSize: '10px', marginTop: '2px' }}>Test</Tag>
            )} */}
          </div>
        </Tooltip>
      ),
    },
    // {
    //   id: 'patientPlan',
    //   name: 'Patient Plan',
    //   selector: 'isPatientPlanCreated',
    //   width: 110,
    //   cell: (record) => (
    //     <Tooltip title={record?.isPatientPlanCreated ? 'Patient plan has been created' : 'Patient plan is pending'}>
    //       <Tag
    //         color={record?.isPatientPlanCreated ? 'green' : 'default'}
    //         style={{ fontSize: '11px', cursor: 'pointer' }}
    //       >
    //         {record?.isPatientPlanCreated ? '✓ Created' : 'Pending'}
    //       </Tag>
    //     </Tooltip>
    //   ),
    // },
    // {
    //   id: 'doctorName',
    //   name: 'Doctor',
    //   selector: 'doctorName',
    //   width: 140,
    //   cell: (record) => (
    //     <Tooltip title={record?.doctorName ? `Assigned Doctor: ${record?.doctorName}` : 'No doctor assigned yet'}>
    //       {record?.doctorName ? (
    //         <span style={{ fontWeight: '500', cursor: 'pointer' }}>{record?.doctorName}</span>
    //       ) : (
    //         <span style={{ color: '#999', fontStyle: 'italic', fontSize: '12px', cursor: 'pointer' }}>Not Assigned</span>
    //       )}
    //     </Tooltip>
    //   ),
    // },
    {
      id: 'careTaker',
      name: 'Care Taker',
      selector: 'careTakerCount',
      width: 100,
      cell: (record) => (
        <Tooltip title={record?.careTakerCount > 0 ? `Care Takers: ${record?.careTakerCount}${record?.careTakerName ? ` (${record?.careTakerName})` : ''}` : 'No care taker'}>
          <div style={{ cursor: 'pointer' }}>
            {record?.careTakerCount > 0 ? (
              <div>
                <Tag color="geekblue">{record?.careTakerCount}</Tag>
                {record?.careTakerName && (
                  <div style={{ fontSize: '11px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '80px' }}>
                    {record?.careTakerName}
                  </div>
                )}
              </div>
            ) : (
              <span style={{ color: '#999', fontSize: '12px' }}>None</span>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      id: 'bookedOn',
      name: 'Booked On',
      selector: 'createdAt',
      width: 110,
      cell: (record) => {
        const fullDate = record?.createdAt ? dayjs(record.createdAt).format('DD MMM YYYY, hh:mm A') : '-';
        return (
          <Tooltip title={`Booked on: ${fullDate}${record?.createdByName ? ` | By: ${record?.createdByName}` : ''}`}>
            <div style={{ fontSize: '12px', color: '#666', cursor: 'pointer' }}>
              {record?.createdAt ? dayjs(record.createdAt).format('DD MMM YY') : '-'}
              {record?.createdByName && (
                <div style={{ fontSize: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '90px' }}>
                  by {record?.createdByName}
                </div>
              )}
            </div>
          </Tooltip>
        );
      },
    },
    // {
    //   id: 'actions',
    //   name: 'Actions',
    //   width: 220,
    //   cell: (record) => (
    //     <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
    //       {canUpdate && record?.status !== 'Completed' && record?.status !== 'Cancelled' && (
    //         <Tooltip title="Update booking status">
    //           <div>
    //             <InputFromUser
    //               type="singleSelect"
    //               name="status"
    //               onChange={newStatus => handleStatusUpdate(record.id || record._id, newStatus)}
    //               options={['Upcoming', 'Completed']}
    //               FormGroupClassName={'cursor-pointer'}
    //               value={record.status}
    //               label=""
    //             />
    //           </div>
    //         </Tooltip>
    //       )}
    //       <Tooltip title={record?.doctorName ? 'Change assigned doctor' : 'Assign a doctor to this booking'}>
    //         <Button
    //           type="primary"
    //           size="small"
    //           onClick={() => SetModal({ is: true, id: record?._id })}
    //           disabled={record.status === 'Completed' || record.status === 'Cancelled'}
    //         >
    //           {record?.doctorName ? 'Change' : 'Assign'}
    //         </Button>
    //       </Tooltip>
    //     </div>
    //   ),
    // },
  ];


  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/solution-slot?page=1">Detox Programs Booking</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Detox Programs List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center justify-content-between">
                          <div className="col-12 col-md-8">
                            <div className="doctor-table-blk">
                              <h3>Detox Programs List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCreate && (
                                    <Link
                                      to="/solution-slot/add-solution-slot"
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}

                                  <Link
                                    to="/solution-slot?page=1"
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {canView ? (
                        <AdvancedTable
                          resource="solution-slot"
                          columns={column}
                          fetchData={fetchSolutionSlotData}
                          filterConfig={filterConfig}
                          enableSearch={false}
                          enableFilters={true}
                          enableHorizontalScrollFeature={true}
                          enableRefresh={true}
                          enableToolBar={true}
                          enableExport={canExport}
                          defaultPageSize={10}
                          persistState={true}
                          tableId="detox-program-bookings-v2"
                          key={`solution-table-${Refresh}`}
                        />
                      ) : (
                        <div className="permission-denied-message">
                          You do not have permission to view detox program bookings.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <AssignDoctorModal
        IsOpen={modal}
        slotType={'solution'}
        initialValues={{
          doctorId: '',
          doctorName: '',
        }}
        Isclose={() => SetModal({ is: false, id: '' })}
      />
    </>
  );
};

export default SolutionSlot;
